class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("keyup", (e) => "Escape" === e.code && this.close());
    this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const e = document.querySelector("#cart-icon-bubble");
    e.setAttribute("role", "button");
    e.setAttribute("aria-haspopup", "dialog");
    e.addEventListener("click", (t) => {
      t.preventDefault();
      this.open(e);
    });
    e.addEventListener("keydown", (t) => {
      "SPACE" === t.code.toUpperCase() && (t.preventDefault(), this.open(e));
    });
  }

  open(e) {
    e && this.setActiveElement(e);
    const t = this.querySelector('[id^="Details-"] summary');
    t && !t.hasAttribute("role") && this.setSummaryAccessibility(t);
    setTimeout(() => {
      this.classList.add("animate", "active");
    });
    this.addEventListener(
      "transitionend",
      () => {
        const e = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const t = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
        trapFocus(e, t);
      },
      { once: true }
    );
    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(e) {
    e.setAttribute("role", "button");
    e.setAttribute("aria-expanded", "false");
    e.nextElementSibling.getAttribute("id") && e.setAttribute("aria-controls", e.nextElementSibling.id);
    e.addEventListener("click", (e) => {
      e.currentTarget.setAttribute("aria-expanded", !e.currentTarget.closest("details").hasAttribute("open"));
    });
    e.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(e) {
    const drawerInner = this.querySelector(".drawer__inner");
    drawerInner?.classList.remove("is-empty", "loading");
    this.productId = e.id;
    this.getSectionsToRender().forEach((t) => {
      (t.selector ? document.querySelector(t.selector) : document.getElementById(t.id)).innerHTML =
        this.getSectionInnerHTML(e.sections[t.id], t.selector);
    });
    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(e, t = ".shopify-section") {
    return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML;
  }

  getSectionsToRender() {
    return [
      { id: "cart-drawer", selector: "#CartDrawer" },
      { id: "cart-icon-bubble" },
    ];
  }

  getSectionDOM(e, t = ".shopify-section") {
    return new DOMParser().parseFromString(e, "text/html").querySelector(t);
  }

  setActiveElement(e) {
    this.activeElement = e;
  }
}

if (!customElements.get("cart-drawer")) customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: "CartDrawer", section: "cart-drawer", selector: ".drawer__inner" },
      { id: "cart-icon-bubble", section: "cart-icon-bubble", selector: ".shopify-section" },
    ];
  }

  enableLoading() {
    this.closest("cart-drawer")?.querySelector(".drawer__inner")?.classList.add("loading");
  }

  disableLoading() {
    document.querySelector("cart-drawer .drawer__inner")?.classList.remove("loading");
  }
}

if (!customElements.get("cart-drawer-items")) customElements.define("cart-drawer-items", CartDrawerItems);
